import {
  Component, OnInit, ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { forkJoin } from "rxjs";
import { MonitoringService } from "../../../shared/services";
import { Utils } from "../../../utils/utils";

@Component({
  templateUrl: "./user-list.component.html",
  styleUrls: ["./user-list.component.css"],
})
export class UserListComponent implements OnInit {
  public displayedColumns = [
    "userID",
    "noOfRequest",
    "minResponseTime",
    "minResponseService",
    "maxResponseTime",
    "maxResponseService",
    "loggedInTime",
    "averageResponseTime",
  ];
  public dataSource = new MatTableDataSource<any>();
  public apiActivityListdataSource = new MatTableDataSource<any>();
  serviceName: string = "";
  key: string = "";
  selectedDate = new FormControl(new Date());
  isLoadingResults: boolean = true;
  top10UserIds: any;
  top10NoOfRequests: Array<number> = undefined;

  top10ApiList: any;
  top10ResponseTimes: Array<number> = undefined;

  // @ViewChild(MatSort) sort: MatSort;
  @ViewChild("paginator") paginator: MatPaginator;

  @ViewChild("apiActivityPaginator") apiActivityPaginator: MatPaginator;

  apiActivitydisplayedColumns = [
    "api",
    "averageResponseTime",
    "firstRequestTime",
    "maxResponseTime",
    "minResponseTime",
    "noOfUserAccessed",
  ];

  constructor(
    private _monitoringService: MonitoringService,
    private _activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.serviceName = this._activatedRoute.snapshot.queryParams["name"];
    this.key = this._activatedRoute.snapshot.queryParams["key"];
  }

  ngAfterViewInit(): void {
    // this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    // this.apiActivityListdataSource.sort = this.sort;
    this.apiActivityListdataSource.paginator = this.apiActivityPaginator;
    this.getUserList(new Date());
  }

  getUserList(date) {
    this.isLoadingResults = true;
    // this._monitoringService
    //   .getUserList(this.serviceName, Utils.formatDate(date))
    //   .subscribe((data) => {
    //     this.isLoadingResults = false;
    //     this.dataSource.data = data;
    //     const slicedArray = data.slice(0, 10);
    //     this.top10UserIds = slicedArray.map(a => a.userID);
    //     this.top10NoOfRequests = slicedArray.map(a => a.noOfRequest);

    //   });

    forkJoin(
      this._monitoringService.getUserActivityDetails(
        this.serviceName,
        Utils.formatDate(date)
      ),
      this._monitoringService.getAPIActivityDetails(
        this.serviceName,
        Utils.formatDate(date)
      )
    ).subscribe(([call1Response, call2Response]) => {
      this.isLoadingResults = false;
      this.dataSource.data = call1Response;
      const slicedArray = call1Response.slice(0, 10);
      this.top10UserIds = slicedArray.map((a) => a.userID);
      this.top10NoOfRequests = slicedArray.map((a) => a.noOfRequest);

      this.apiActivityListdataSource.data = call2Response;
      const slicedApiLists = call2Response.slice(0, 10);
      this.top10ApiList = slicedApiLists.map((a) => a.api);
      this.top10ResponseTimes = slicedApiLists.map(
        (a) => a.averageResponseTime
      );
    });
  }

  onUserRowclick(row) {
    this.navigateToActivityList(row.userID, null);
  }

  navigateToActivityList(userID: string, apiName: string) {
    if (userID) {
      this.router.navigate([`activity-list`], {
        queryParams: {
          name: this.serviceName,
          user: userID,
          date: Utils.formatDate(this.selectedDate.value),
        },
      });
    } else {
      this.router.navigate([`activity-list`], {
        queryParams: {
          name: this.serviceName,
          api: apiName,
          date: Utils.formatDate(this.selectedDate.value),
        },
      });
    }
  }

  onUserChartSelected(userID: any) {
    this.navigateToActivityList(userID, null);
  }

  onApiListRowclick(row) {
    this.navigateToActivityList(null, row.api);
  }

  onApiChartSelected(value: any) {
    this.navigateToActivityList(null, value);
  }

  onDateChange(date) {
    this.selectedDate = new FormControl(new Date(date));
    this.getUserList(new Date(date));
  }
}
